import React from 'react';
import { getBrand } from '../config/brand.js';
import InterviewFlowDashboard from '../components/InterviewFlow/InterviewFlowDashboard.jsx';
import BaigLabsLaunchpad from './BaigLabsLaunchpad.jsx';

function Dashboard() {
  if (getBrand() === 'interviewflow') {
    return <InterviewFlowDashboard />;
  }
  return <BaigLabsLaunchpad />;
}

export default Dashboard;
